import { del, get, upload, put } from '@api/request';

export const fetchDocuments = async (
  { assessmentService },
  authenticationToken,
  { taxingUnitID, year },
) => {
  const url = `${assessmentService}/assessment/taxingunit/documents/${taxingUnitID}/${year}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const createDocument = async (
  { assessmentService },
  authenticationToken,
  { taxingUnitID, year, payload },
) => {
  const url = `${assessmentService}/assessment/taxingunit/documents/${taxingUnitID}/${year}`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const updateDocument = async (
  { assessmentService },
  authenticationToken,
  { payload },
) => {
  const { taxingUnitDocumentID } = payload;
  const url = `${assessmentService}/assessment/taxingunit/document/${taxingUnitDocumentID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deleteDocument = async (
  { assessmentService },
  authenticationToken,
  { payload: { taxingUnitDocumentID } },
) => {
  const url = `${assessmentService}/assessment/taxingunit/document/${taxingUnitDocumentID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const getDocument = async (
  { assessmentService },
  authenticationToken,
  { payload: { taxingUnitDocumentID } },
) => {
  const url = `${assessmentService}/assessment/taxingunit/document/${taxingUnitDocumentID}`;
  const { body } = await get(authenticationToken, url, {
    outputType: 'bytearray',
  });
  return body;
};
